<template lang="pug">
.login-psc
  button(v-on:click="redirectToPSC" :disabled="isLoginProgress")
    img(src="/images/pro-sante-connect.png")
</template>

<script setup lang="ts">
const userStore = useUserStore()
const isLoginProgress = computed(() => {
  return userStore.isLoginProgress
})
function redirectToPSC() {
  localStorage.setItem('isWeb', 'true')
  navigateTo('/auth/psc-login')
}
</script>

<style lang="stylus" scoped>
.login-psc
  display flex
  flex-direction column
  align-items flex-end
  flex 1
  font-family Roboto
  font-size 19px
  font-style normal
  font-weight 600
  button
    img
      width 220px
  button:disabled
  button[disabled]
    opacity 0.3
</style>
